import React from 'react';

/**
 * On/off switch. Controlled: it reports the click and lets the parent decide, because the page's
 * toggles (commuter, medical approval) confirm or call the API before the value changes.
 */
const Toggle = ({ checked, onChange, label, disabled }) => (
    <button
        type="button"
        role="switch"
        aria-checked={!!checked}
        aria-label={label}
        disabled={disabled}
        onClick={onChange}
        className={`tw-relative tw-inline-flex tw-h-5 tw-w-9 tw-shrink-0 tw-items-center tw-rounded-full tw-transition-colors focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-brand-300 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 ${checked ? 'tw-bg-brand-600' : 'tw-bg-neutral-300'}`}
    >
        <span className={`tw-inline-block tw-h-4 tw-w-4 tw-rounded-full tw-bg-white tw-shadow tw-transition-transform ${checked ? 'tw-translate-x-[18px]' : 'tw-translate-x-0.5'}`} />
    </button>
);

export default Toggle;
